<template lang="html">
  <span>
    <!-- Delete -->
    <b-button
      v-b-modal="modalId + 'delete'"
      size="sm"
      variant="outline-secondary"
      :disabled="updating"
      @click="loadShow()"
    >
      Delete <v-icon name="trash-alt" />
    </b-button>
    <!-- Spinner for updating -->
    <v-icon v-show="updating" name="circle-notch" spin class="ml-2 mt-1" />

    <!-- Delete Modal -->
    <b-modal
      :id="modalId + 'delete'"
      title="Delete Show"
      ok-title="Delete"
      header-bg-variant="danger"
      header-text-variant="light"
      ok-variant="danger"
      :ok-disabled="!areUploadCredentialsValid(show)"
      @ok="
        updating = true;
        $store.dispatch('shows/deleteShow', show);
      "
    >
      <div v-if="areUploadCredentialsValid(show)">
        <p class="my-4">
          Confirm deletion of <em>{{ show.title }}.</em>
        </p>
        <p v-show="show.published" class="my-4">
          This show will remove the show from your account.
        </p>
      </div>
      <div v-else>
        Credentials updating ...
      </div>
    </b-modal>
  </span>
</template>

<script>
import { db } from "@/fstore";
export default {
  name: "ShowConfirmActionButton",
  props: {
    showDetails: {
      required: true,
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      show: {},
      unbindFunction: null,
      updating: false
    };
  },
  computed: {
    modalId() {
      return `ButtonModal-${this.showKey}`;
    },
    showKey() {
      return this.showDetails.key;
    },
    lastUpdate() {
      return this.showDetails.updated_at;
    }
  },
  watch: {
    lastUpdate(newValue, oldValue) {
      if (newValue != oldValue) {
        this.updating = false;
      }
    }
  },
  beforeDestroy() {
    if (this.unbindFunction) {
      this.unbindFunction();
    }
  },
  methods: {
    loadShow() {
      console.log("loadShow", this.showKey);
      // Note: Getting data once. This isn't binding for realtime updates.
      var _v = this;
      _v.unbindFunction = db
        .collection("editor_shows")
        .doc(this.showKey)
        .onSnapshot(function(doc) {
          console.log("Current data: ", doc.data());
          _v.show = doc.data();
          _v.prepareCredentials();
        });
    },
    prepareCredentials() {
      console.log("prepareCredentials");
      this.$store.dispatch("editor/updateCredentialsIfNeeded", this.show);
    },
    areUploadCredentialsValid(show_obj) {
      //console.log("areUploadCredentialsValid");
      // Reminder, credentials are issued for 24 hours.
      var current_dt = new Date().getTime();
      if ("audioCredentialsV4" in show_obj) {
        var msUntilExpiration =
          show_obj.audioCredentialsV4.expiration - current_dt;
        var hoursUntilRefresh = 2; // Reminder, credentials are issued for 24 hours.
        var msRefreshLimit = 1000 * 60 * 60 * hoursUntilRefresh;
        // console.log("msUntilExpiration", msUntilExpiration);
        // console.log("msRefreshLimit", msRefreshLimit);
        if (msUntilExpiration > msRefreshLimit) {
          //console.log(
          //  `Credentials don't expire for at least ${hoursUntilRefresh} hours. All good.`
          //);
          return true;
        }
      }
      //console.log("Credentials expired or don't exist.");
      return false;
    }
  }
};
</script>

<style lang="scss" scoped></style>
